import {useEffect} from "react";

export function Home() {
    useEffect(() => {
        navigator.serviceWorker.ready.then(reg => {
            console.log('SW activo: ' + reg.scope);
        }).catch(err => {
            console.log('SW error: ' + err);
        });
    }, []);
    return (
        <div className="home" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <img src="/rc2.png" alt="Logo" style={{ maxWidth: '50%', height: 'auto' }} />
        </div>
    );
}